"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogSourceParams = void 0;
var log_source_1 = require("./log-source");
var LogSourceParams = (function () {
    function LogSourceParams(enabled, logSource) {
        this.enabled = enabled;
        this.logSource = logSource;
        this.name = log_source_1.LogSource[logSource];
    }
    LogSourceParams.prototype.getName = function () {
        return this.name;
    };
    LogSourceParams.prototype.isEnabled = function (_functionInfo) {
        return this.enabled;
    };
    LogSourceParams.prototype.setEnabled = function (isEnable) {
        this.enabled = isEnable;
    };
    LogSourceParams.prototype.handle = function (_functionInfo, _valOrFunc) {
        return false;
    };
    return LogSourceParams;
}());
exports.LogSourceParams = LogSourceParams;
